function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var _ref = /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  y: 0.5,
  width: 21,
  height: 21,
  rx: 1.5,
  fill: "white",
  stroke: "#CCDDEE"
});
var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 6.5,
  cy: 11,
  r: 1.5,
  fill: "#00AAFF"
});
var _ref3 = /*#__PURE__*/React.createElement("circle", {
  cx: 11,
  cy: 11,
  r: 1.5,
  fill: "#00AAFF"
});
var _ref4 = /*#__PURE__*/React.createElement("circle", {
  cx: 15.5,
  cy: 11,
  r: 1.5,
  fill: "#00AAFF"
});
const Svg3DotsButton = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 22,
  height: 22,
  viewBox: "0 0 22 22",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref, _ref2, _ref3, _ref4);
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(Svg3DotsButton, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/3dotsButton.a8a8e712.svg";
export { ForwardRef as ReactComponent };